import { ISidebarConfig, ISidebarSection } from '../components/sidebar-menu/sidebar-menu.interface';
import { BASE_SIDEBAR_SECTION } from './base.config';
import { GUARD_SIDEBAR_SECTION } from './guard.config';

export const SUPERVISOR_SIDEBAR_SECTION: ISidebarSection = {
    id: 'vigilantes',
    title: 'Gestão de Vigilantes',
    items: [
        {
            id: 'vigilantes',
            title: 'Funcionários',
            route: '/hr/funcionarios',
            icon: 'users',
            isVisible: true,
        },
    ],
};

export const SUPERVISOR_SIDEBAR_CONFIG: ISidebarConfig = {
    role: 'SUPERVISOR',
    sections: [BASE_SIDEBAR_SECTION, SUPERVISOR_SIDEBAR_SECTION, GUARD_SIDEBAR_SECTION],
};
